import { render, staticRenderFns } from "./dispatchList.vue?vue&type=template&id=614af552&scoped=true&"
import script from "./dispatchList.vue?vue&type=script&lang=js&"
export * from "./dispatchList.vue?vue&type=script&lang=js&"
import style0 from "./dispatchList.vue?vue&type=style&index=0&id=614af552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614af552",
  null
  
)

export default component.exports